import React from 'react';

const DashboardLayout = ({ title, subtitle, children, actions }) => {
  return (
    <section className="dashboard-shell">
      <header className="dashboard-shell-header">
        <div>
          <h2>{title}</h2>
          <p>{subtitle}</p>
        </div>
        {actions ? <div>{actions}</div> : null}
      </header>
      <div className="dashboard-shell-body">{children}</div>
    </section>
  );
};

export default DashboardLayout;
